import { render, staticRenderFns } from "./MediaCard.vue?vue&type=template&id=d2cb7254&scoped=true&"
import script from "./MediaCard.vue?vue&type=script&lang=ts&"
export * from "./MediaCard.vue?vue&type=script&lang=ts&"
import style0 from "./MediaCard.vue?vue&type=style&index=0&id=d2cb7254&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2cb7254",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VChip,VIcon,VImg,VProgressCircular,VRow})
